import { ReactComponent as AppsIcon } from '@Icons/additional/widgets.svg';

import './header-actions.css';

const Apps: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className="header-action-component apps trojan-neumorphism-box trojan-neumorphism-box-shadow">
      {text && <span>{text}</span>} <AppsIcon />
    </div>
  );
};

export default Apps;
